import {
    Component, EventEmitter, inject, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges
} from '@angular/core';


import {ActivatedRoute} from "@angular/router";
import {
    UiCustomerExternalAlias
} from "../../../../../../page/consultant-page/object/cr-customer-object-page/data/ui-customer-external-alias";
import {WidgetData} from "../../../../../../../../core/shared/widget/widget-data";
import {CustomerDto} from "../../../../../../model/dto/entity/customer.dto";
import {ProfileCheckResultDto} from "../../../../../../model/dto/api/profile-check-result.dto";
import {CustomerAssessmentResultDto} from "../../../../../../model/dto/api/customer-assessment-result.dto";
import {ProfileCheckResultEntryDto} from "../../../../../../model/dto/api/profile-check-result-entry.dto";
import {MvsCoreService} from "../../../../../../../../core/shared/service/mvs-core.service";
import {CustomerService} from "../../../../../../service/api/customer.service";
import {MvsObjectNavigationService} from "../../../../../../../../core/shared/navigation/mvs-object-navigation.service";
import {ObjectRequestList} from "../../../../../../../../core/shared/dto/object/request/object-request-list";
import {FilterCriteria} from "../../../../../../../../core/shared/filter/api/filter.criteria";
import {ObjectRequestComplex} from "../../../../../../../../core/shared/dto/object/request/object-request-complex";
import {
    ObjectRequestComplexNode
} from "../../../../../../../../core/shared/dto/object/request/object-request-complex-node";
import {ObjectRequestRelation} from "../../../../../../../../core/shared/dto/object/request/object-request-relation";
import {DtoList} from "../../../../../../../../core/shared/dto/dto.list";
import {MvsFormDto} from "../../../../../../../../core/shared/dto/form/dto/mvs-form.dto";
import {CustomerExternalAliasDto} from "../../../../../../model/dto/entity/customer-external-alias.dto";
import {WidgetFactory} from "../../../../../../../../core/shared/widget/service/widget.factory";
import {MvsCrudService} from "../../../../../../../../core/shared/service/crud/mvs-crud.service";
import {
    WidgetToolbarCallbackInterface
} from "../../../../../../../../core/shared/widget/widget-toolbar-callback.interface";
import {DtoDetail} from "../../../../../../../../core/shared/dto/dto.detail";
import {MvsFormControlOverwrite} from "../../../../../../../../core/shared/logic/form/logic/mvs-form-control-overwrite";
import {MvsFormFieldAccessEnum} from "../../../../../../../../core/shared/logic/form/logic/mvs-form-field-access.enum";
import {MvsObjectNavigationEntry} from "../../../../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {
    MvsObjectNavigationActionEnum
} from "../../../../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {Observable} from "rxjs";
import {CR_EXTERNAL_SYSTEM_LINKS} from "../../../../../../service/token/cr-external-system-link.token";
import {
    buildCrExternalCustomerUrl,
    findCrExternalSystemTarget
} from "../../../../../../logic/cr-external-system-link";


@Component({
    selector: 'cr-customer-header-consultant',
    templateUrl: './cr-customer-header-consultant.component.html',
    standalone: false,
})
export class CrCustomerHeaderConsultantComponent implements OnInit, OnChanges, OnDestroy {

    customerDto: CustomerDto;
    customerExternalAliasWidget: WidgetData;
    uiExternalAlias: UiCustomerExternalAlias[];
    profileCheckData: ProfileCheckResultDto;
    contractHealthData: CustomerAssessmentResultDto;
    photoUrl: Observable<string>;
    formattedDuration: string;
    failedChecks: (ProfileCheckResultEntryDto[] | ProfileCheckResultEntryDto)[];
    pcActiveIndex: number | number[];

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized
    @Input() customerId: number;
    @Output() customerDtoChange: EventEmitter<CustomerDto> = new EventEmitter();

    /** System host → consultant app of the other tenant; provided per environment by the consultant shell. */
    private readonly externalSystemLinks = inject(CR_EXTERNAL_SYSTEM_LINKS);
    /** systemDtoId → base URL of the app the alias opens in; a system without entry gets no link. */
    externalSystemTargets: Record<number, string> = {};

    constructor(protected route: ActivatedRoute, protected coreService: MvsCoreService, protected customerService: CustomerService, protected navigationService: MvsObjectNavigationService) {

    }


    ngOnInit(): void {
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.getCustomer();
    }

    getCustomer() {

        // Marko 20.12.2024 Method was retired as the Customer Name is passed within the field calculatedName of the Customer now
        // The references of this.customerDto.personDtoName where replaced with customer.calculatedName
        const crudService = this.coreService.getCrudService('cr.Customer');
        const objectRequest = new ObjectRequestList(true,
            [FilterCriteria.create('id', FilterCriteria.cOperatorEqual, this.customerId)],
            []
        );

        objectRequest.objectRequestComplex = ObjectRequestComplex.build(true, false,
            ObjectRequestComplexNode.createRelationNode('customerExternalAlias', ObjectRequestRelation.createJoin('cr.CustomerExternalAlias#customer'))
                .addNodes(ObjectRequestComplexNode.createSimpleAttributeNode('system')),
            ObjectRequestComplexNode.createRelationNode("lastSuccessfulCall", ObjectRequestRelation.createJoin("+lastSuccessfulCall")),
            ObjectRequestComplexNode.createRelationNode("lastLoginDevice", ObjectRequestRelation.createJoin("+lastLoginDevice"))
        );

        crudService.list(objectRequest).subscribe((value: DtoList<CustomerDto>) => {
            this.customerDto = value.entries[0];
            this.formattedDuration = this.secondsToMmss(this.customerDto?.lastSuccessfulCall?.durationInSeconds);
            this.customerDtoChange.emit(this.customerDto);


            if (this.customerDto?.customerExternalAlias && this.customerDto.customerExternalAlias?.length) {
                this.prepareUiExternalAlias();
                this.refreshCustomerExternalAliasWidget(value.form);
            } else {
                this.uiExternalAlias = [];
            }

            this.getPhoto();
            this.initialized = true;
        });


    }

    prepareUiExternalAlias() {
        this.uiExternalAlias = [];
        this.externalSystemTargets = {};

        for (let item of this.customerDto.customerExternalAlias) {

            const exists = this.uiExternalAlias.find(alias => alias.systemDtoId == item.systemDtoId);

            if (exists) {
                continue;
            }

            const uiAlias = new UiCustomerExternalAlias();

            uiAlias.systemDtoId = item.systemDtoId;
            uiAlias.systemDto = item.systemDto;
            uiAlias.uiAliasList = [];

            const target = findCrExternalSystemTarget(this.externalSystemLinks, item.systemDto?.url);
            if (target) {
                this.externalSystemTargets[item.systemDtoId] = target;
            }

            // find entries of same system id
            const entries = this.customerDto.customerExternalAlias.filter(v => v.systemDtoId == item.systemDtoId);

            for (let entry of entries) {
                uiAlias.uiAliasList.push(entry.externalAlias);
            }

            this.uiExternalAlias.push(uiAlias);
        }


    }

    refreshCustomerExternalAliasWidget(form: MvsFormDto) {
        const dtoList = new DtoList<CustomerExternalAliasDto>();
        dtoList.entries = this.customerDto.customerExternalAlias;
        dtoList.form = form.getSubForm('customerExternalAlias');

        this.customerExternalAliasWidget = WidgetFactory.createWidgetTransient(
            'cr.customer.main.page.external.alias.basic',
            "Externe Verknüpfungen",
            'list',
            'transient',
            'transient',
            "cr.CustomerExternalAlias",
            MvsCrudService.transformDtoListOutToIn(dtoList));

        this.customerExternalAliasWidget.functionCallbacks = this.customerFunctionCallback();
    }

    customerFunctionCallback() {
        return {
            onFunctionCreateNew: (widgetData: WidgetData): WidgetToolbarCallbackInterface => {
                const dto = new DtoDetail();
                dto['customerDtoId'] = this.customerId;
                const formControlOverwrite = new MvsFormControlOverwrite();
                formControlOverwrite.addField('customerDtoId', MvsFormFieldAccessEnum.HIDDEN);

                let test: WidgetToolbarCallbackInterface;
                test = {
                    dto: dto,
                    formControlOverwrite: formControlOverwrite
                };
                return test;
            }
        };
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["customerId"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
    openObjectDrawer(id: number) {
        const mvsObjectNavigationEntry = MvsObjectNavigationEntry.createNavigationEntry('pm.Person', id, null, "", null, null, MvsObjectNavigationActionEnum.display);
        this.navigationService.navigateTo(mvsObjectNavigationEntry, 'left');
    }

    getPhoto() {
        const crudServiceCustomer: CustomerService = <CustomerService>this.coreService.getCrudService("cr.Customer");
        this.photoUrl = crudServiceCustomer.getPhotoUrl(this.customerId);
    }

    secondsToMmss(seconds: number): string {
        if (isNaN(seconds) || seconds < 0) return '00:00';

        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;

        const paddedMins = mins.toString().padStart(2, '0');
        const paddedSecs = secs.toString().padStart(2, '0');

        return `${paddedMins}:${paddedSecs}`;
    }

    createTicket() {
        const mvsObjectNavigationEntry = MvsObjectNavigationEntry.createNavigationEntry("tm.Ticket", 0, "Ticket", null, null, null, MvsObjectNavigationActionEnum.create, 'side', null, 'consultant');
        this.navigationService.navigateTo(mvsObjectNavigationEntry, 'right');

        const dto = new DtoDetail();
        dto['groupDtoId'] = 1;

    }
    isArray(value: any): value is any[] {
        return Array.isArray(value);
    }


    /**
     * Opens the customer `alias` in the consultant app of the external system, in a new tab.
     */
    openExternalSystemCustomer(systemDtoId: number, alias: string) {
        const url = buildCrExternalCustomerUrl(this.externalSystemTargets[systemDtoId], alias);
        if (url) {
            window.open(url, '_blank');
        }
    }

    openProxyWebAppLogin() {

        if (this.busy) {
            return;
        }

        this.busy = true;

        this.customerService.generateProxyPassCode(this.customerDto.id).subscribe(res => {

            window.open("https://kvers.de/#/passCodeLogin/?passCode=" + res.passCode);

            this.busy = false;
        }, error => {
            //TODO: Show Error Message
            this.busy = false;
        });
    }

}
